import React, { Component } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import cs1 from '../../images/causes/1.png'
import cs2 from '../../images/causes/2.png'
import cs3 from '../../images/causes/3.png'
import cs4 from '../../images/causes/4.png'

import './style.css'

class CaseSlide extends Component {

  render() {
    var settings = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      margin: 10,
      loop: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true
          }
        }
      ]
    };

    const causesData = [
      {
        id: 1,
        title: "Awareness",
        image: cs1,
        items: [
          "Road Safety",
          "Drugs",
          "ISI Mark",
          "AIDS",
          "Cybercrime",
          "Voter Awareness",
          "Power of Vote"
        ]
      },
      {
        id: 2,
        title: "Environment",
        image: cs2,
        items: [
          "Save Nature",
          "Plastic Pollution",
          "Save Deepor Beel"
        ]
      },
      {
        id: 3,
        title: "Society",
        image: cs3,
        items: [
          "Women Empowerment",
          "Child Marriage",
          "Child Labour"
        ]
      },
      {
        id: 4,
        title: "Health",
        image: cs4,
        items: [
          "Cancer",
          "Mental Health",
          "Tobacco"
        ]
      }
    ];

    return (
      <div className="wpo-case-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wpo-section-title">
                <span>Our Causes</span>
                <h2>Issues We Address Through Mime</h2>
              </div>
            </div>
          </div>
          <div className="wpo-case-wrap">
            <div className="wpo-case-slider">
              <Slider {...settings}>
                {causesData.map((cause) => (
                  <div key={cause.id} className="wpo-case-single">
                    <div className="wpo-case-item">
                      <div className="wpo-case-img">
                        <img src={cause.image} alt={cause.title} />
                      </div>
                      <div className="wpo-case-content">
                        <div className="wpo-case-text-top">
                          <h2>{cause.title}</h2>
                          <div className="causes-list">
                            <ul>
                              {cause.items.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CaseSlide;




